import { encodeAsFormData } from './encodeAsFormData.js'
import { getRedrockHeaders, FORM_CONTENT_TYPE_HEADER } from './headers.js'
import { isSpringControllerUrl, isStreamApiUrl } from './requestTypes.js'
import {
  GET,
  POST,
  PUT,
  URI_FIELD_FORM_ENCODING_FIX_REGEX,
} from './constants.js'
import { hasJSONHeader, hasFormHeader } from './utilities.js'
import { getAuthorizationHeader, getCredentialsSetting } from './configuration'

export default function applyDefaultsAndMergeOptionsOverrides(
  url,
  fetchOptions,
  tracking
) {
  if (isStreamApiUrl(url)) {
    return getStreamApiConfig(fetchOptions, tracking)
  } else if (isSpringControllerUrl(url)) {
    return getSpringControllerConfig(fetchOptions)
  } else {
    return getAllOtherConfig(fetchOptions)
  }
}

function getMethod(fetchOptions) {
  if (fetchOptions.method === undefined) {
    return fetchOptions.body === undefined ? GET : POST
  }

  return fetchOptions.method
}

function getStreamApiConfig(fetchOptions, tracking) {
  let body = fetchOptions.body

  const method = getMethod(fetchOptions)
  const credentials = getCredentialsSetting()
  const headers = {
    ...getRedrockHeaders(),
    ...FORM_CONTENT_TYPE_HEADER,
    ...fetchOptions.headers,
  }

  const bodyIsAlreadyFormatted = typeof body === 'string'

  if (!bodyIsAlreadyFormatted && method !== GET) {
    if (hasFormHeader(headers)) {
      body = addMethodToBody(method, body)

      if (body.method) {
        tracking.method = body.method
      }

      body = encodeAsFormData(body).replace(
        URI_FIELD_FORM_ENCODING_FIX_REGEX,
        'uri'
      )
    } else if (hasJSONHeader(headers)) {
      body = JSON.stringify(body)
    }
  }

  return {
    ...fetchOptions,
    body,
    credentials,
    headers,
    method,
  }
}

function getSpringControllerConfig(fetchOptions) {
  const method = getMethod(fetchOptions)
  const credentials = getCredentialsSetting()

  return {
    ...fetchOptions,
    body: fetchOptions.body,
    credentials,
    method,
    headers: {
      ...getRedrockHeaders(),
      ...fetchOptions.headers,
    },
  }
}

function getAllOtherConfig(fetchOptions) {
  const authorizationHeader = getAuthorizationHeader()
  if (authorizationHeader) {
    return {
      ...fetchOptions,
      headers: {
        ...fetchOptions.headers,
        Authorization: authorizationHeader,
      },
    }
  }

  return fetchOptions
}

function addMethodToBody(method, body = {}) {
  if (body.method === undefined) {
    if (body.action) {
      body.method = PUT
    } else {
      body.method = method
    }
  }

  return body
}
